import { ArrowLeft } from 'lucide-react';
import { AppLogo } from '@/components/AppLogo';
import { Button } from '@/components/ui/button';

type Props = {
  onHome: () => void;
  onBack: () => void;
};

export function ClientHeader({ onHome, onBack }: Props) {
  return (
    <div className='flex items-center justify-between mb-5'>
      <Button variant='ghost' onClick={onHome} className='hover:opacity-80 p-0 h-auto'>
        <AppLogo />
      </Button>
      <Button variant='outline' onClick={onBack} className='gap-2'>
        <ArrowLeft className='w-4 h-4' /> Назад
      </Button>
    </div>
  );
}
